var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.615,
    height: 32.615,
    viewBox: "0 0 32.615 32.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1669",
    "data-name": "Group 1669",
    transform: "translate(-394 -726.294)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 16.307,
    cy: 16.307,
    r: 16.307,
    transform: "translate(394 726.294)",
    fill: "#fe022c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496",
    transform: "translate(-1425.482 1693.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M1836.537-958.153q-.057.506-.114,1.012a1.5,1.5,0,0,0-.025.271c.012.165-.064.185-.211.192a12.816,12.816,0,0,0-1.486.11,5.494,5.494,0,0,0-2.67,1.258,5.808,5.808,0,0,0-2,3.3,5.682,5.682,0,0,0,.41,3.658,5.822,5.822,0,0,0,2.518,2.711,5.681,5.681,0,0,0,3.2.72,5.766,5.766,0,0,0,3.762-1.7,5.679,5.679,0,0,0,1.7-3.434c.049-.4.04-.812.056-1.219,0-.057,0-.113,0-.18l1.392-.148.078.349v.891c-.009.051-.019.1-.026.153-.044.308-.068.62-.133.923a7.211,7.211,0,0,1-2.442,4.09,7.173,7.173,0,0,1-5.5,1.723,7.023,7.023,0,0,1-3.869-1.6,7.24,7.24,0,0,1-2.738-5.389,6.836,6.836,0,0,1,.714-3.493,7.284,7.284,0,0,1,5.383-4.084c.271-.052.548-.076.823-.114Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M2099.356-953.725l-1.263-.01h-.2v-1.875l-2.625,2.628-1.064-1.064,2.636-2.632h-1.912v-1.475h4.428Z",
    transform: "translate(-256.205 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M2013.777-872.849h2.194v1.476h-.157c-1.116,0-2.232,0-3.348,0-.131,0-.169-.033-.168-.167q.007-2.414,0-4.828c0-.131.034-.171.167-.168.388.009.776.008,1.164,0,.123,0,.151.039.15.155,0,1.111,0,2.222,0,3.333Z",
    transform: "translate(-177.249 -78.68)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckout);
export default __webpack_public_path__ + "static/media/checkout.11943338a3fb19c37e9c2cb6f2e237b4.svg";
export { ForwardRef as ReactComponent };